import { render, staticRenderFns } from "./main.vue?vue&type=template&id=042a5970"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('042a5970')) {
      api.createRecord('042a5970', component.options)
    } else {
      api.reload('042a5970', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=042a5970", function () {
      api.rerender('042a5970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/YLImage/main.vue"
export default component.exports